import React from 'react'
import useIncompleteUserReflections from './use-incomplete-user-reflections'
import Modal from '../../modals/confirmation'
import ConsentForm from '../consent'

const UserReflectionInquiry = ({
    children
}) => {
    const { hasReflections, toReflection, dismiss } = useIncompleteUserReflections()
    if (hasReflections) {
        return (
            <ConsentForm
                onConfirm={() => toReflection()}
                onCancel={() => dismiss()}
                title = 'Reflection waiting...'
                description='You have a reflection avaiable!'
            />
        )
    }

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

export default UserReflectionInquiry
